<template>
  <h1>About</h1>
  <router-link to="/">Back</router-link>
</template>